import { render, staticRenderFns } from "./ItemVariation.vue?vue&type=template&id=fc2a3fbc&scoped=true"
import script from "./ItemVariation.vue?vue&type=script&lang=js"
export * from "./ItemVariation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc2a3fbc",
  null
  
)

export default component.exports